/**
 * True when the app is running in a development environment (local or deployed dev frontend).
 * Use to show dev-only UI (e.g. developer mode button, allow accessing pending applicant pages).
 */
export const isDevEnvironment = () =>
  process.env.NODE_ENV === "development" ||
  (process.env.REACT_APP_FRONTEND_URL &&
    (process.env.REACT_APP_FRONTEND_URL.includes("frontend-dev-dot") ||
      process.env.REACT_APP_FRONTEND_URL.includes("frontend-dev2-dot")));
